module.exports = __webpack_public_path__ + "static/media/secondfloor.ebd32611.png";